module.exports = __webpack_public_path__ + "62ffb6614b30d6a953e3891ab019f4d2.jpg";